/** 付箋のデフォルトサイズ（px） */
export const STICKY_NOTE_DEFAULT_SIZE = { width: 200, height: 150 } as const;

/** 付箋の最小サイズ（px） */
export const STICKY_NOTE_MIN_SIZE = { width: 120, height: 80 } as const;

/** 付箋のタイトルバーの高さ（px） */
export const STICKY_NOTE_TITLE_BAR_HEIGHT = 28;
